import { CREATE_TAG, GET_TAG, SET_ALL_TAGS, SET_ALL_TAGS_SELECT, UPDATE_TAG } from "../../reducerTypes"

const initialState = {
  getData: {},
  getList: [],
  selectData: [],
}

const tagReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_TAGS:
      return{
        ...state,
        getList: action.payload
      }
    case CREATE_TAG:
      return{
        ...state,
        getData: action.payload
      }
    case GET_TAG:
    return{
      ...state,
      getData: action.payload
    }
    case UPDATE_TAG: 
    return{
      ...state,
      getData: action.payload
    }
    case SET_ALL_TAGS_SELECT:
      const contentData = action.payload ? action.payload : [];
      const selectData = [];
      contentData.map((data)=>{
        selectData.push({
          value: data.id,
          label: `${data.name}`
        })
        return data
      });
      return{
        ...state,
        selectData: selectData
      }
    default:
      return state
  }
}

export default tagReducer
